<template>
  <div class="calendar-week">
    <div
      v-for="(day, keyDay) in weeks"
      :key="keyDay"
      class="calendar-week__day"
    >
      <span v-text="day"> </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    weeks: Array
  },
  inheritAttrs: false
});
</script>
<style scoped lang="scss">
.calendar-week {
  display: grid;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-top: 0.125rem;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  border-bottom-width: 1px;

  &__day {
    font-size: 1.4rem;
    line-height: 1;
    font-weight: 500;
    letter-spacing: 0.025em;
    text-align: center;
    cursor: default;
  }
}
</style>